// The marketing header's mobile menu is a <details>, which only closes from its own toggle.
// Close it when a link inside is picked (most jump to a section of the same page, where the
// open menu would cover it), on Escape, and on a click outside. Like the scroll header, it
// lives in the root layout outside any LiveView, so it's a plain listener rather than a hook.
const menu = document.querySelector('[data-mobile-menu]');

if (menu) {
  const close = ({ refocus = false } = {}) => {
    if (!menu.open) return;
    menu.open = false;
    if (refocus) menu.querySelector('summary').focus();
  };

  menu.addEventListener('click', event => {
    if (event.target.closest('a')) close();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') close({ refocus: menu.contains(document.activeElement) });
  });

  document.addEventListener('pointerdown', event => {
    if (!menu.contains(event.target)) close();
  });
}
